var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.18 0 0 7.18 0 16C0 24.82 7.18 32 16 32C24.82 32 32 24.82 32 16C32 7.18 24.82 0 16 0ZM16 1.33333C24.0867 1.33333 30.6667 7.91333 30.6667 16C30.6667 19.24 29.6067 22.24 27.82 24.6733C27.3667 23.0667 26.0067 21.78 23.9667 21.1467L16 19.66L8.1 21.1467C6.07333 21.6533 4.65333 22.9867 4.18 24.68C2.39333 22.2467 1.33333 19.2533 1.33333 16.0067C1.33333 7.91333 7.91333 1.33333 16 1.33333ZM16 30.6667C11.8 30.6667 8.00667 28.8867 5.33333 26.0533V25.8867C5.33333 23.9133 6.92667 22.8133 8.38667 22.4467L16.0067 21.0133L23.6133 22.4333C24.5667 22.74 26.6733 23.6667 26.6733 25.8867V26.06C24 28.9 20.2067 30.6733 16.0067 30.6733L16 30.6667Z",
    fill: "#06A099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 12.6067C11.7133 15.4733 13.5933 17.3333 16 17.3333C18.4066 17.3333 20.2533 15.5267 20.8 12.62C20.8866 12.18 21.3066 9.94 21.3266 9.39333C21.3866 8 20.8866 6.68 19.92 5.66667C18.9066 4.60667 17.48 4.00667 16 4.00667C14.52 4.00667 13.0666 4.62667 12.0466 5.70667C11.0866 6.72667 10.6 8.04 10.6733 9.40667C10.7066 9.96 11.1533 12.3533 11.2 12.6133V12.6067ZM13.0133 6.61333C13.78 5.8 14.8733 5.33333 16 5.33333C17.1266 5.33333 18.1933 5.78667 18.9533 6.58667C19.6666 7.33333 20.04 8.31333 19.9933 9.33333C19.98 9.68 19.6733 11.38 19.4866 12.3667C19.1533 14.12 18.0666 16 16 16C13.9333 16 12.8133 14.0467 12.5133 12.3733C12.3266 11.38 12.0266 9.68 12.0066 9.32667C11.9533 8.32667 12.3066 7.36 13.0133 6.61333Z",
    fill: "#06A099"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.eddc749859a89366e0b60bd544303082.svg";
export { ForwardRef as ReactComponent };